import { connect } from 'react-redux'
import React, { Component, Fragment } from 'react'
import FontAwesome from 'react-fontawesome'

import BoxSection from '../Layout/BoxSection'
import BoxButton from '../Layout/BoxButton'
import ModalDelete from '../Shared/ModalDelete'

import { 
    downloadFile,
    displayModalAddFile,
    showHideModalDelete
} from '../../actions/common'

import {
    isAllowedToViewComponent
} from '../../utils/helpers'

class AttachedFilesBox extends Component {


    constructor(props) {
		super(props)
		this.state = {
            toggleAll: false
		}
    }



	setIcon = (icon) => {
		if (icon) {
			const imageSrc = require('../../img/16px/' + icon)
			return <img src={ imageSrc } />
		}
		return null
    }
    
    toggleSelectAllFiles = (checked) => {

        const { files } = this.props
        const root = this.props.root ? `${this.props.root}.` : ''

        this.setState({
            toggleAll: checked
        })

        files.forEach((x, n) => {
            if (x.get('editable')) {
                this.props.updateInputs(`${root}adjuntos.${n}.selected`, checked)
            }
        })
    }

    render() {

        

        const { files, obj, check, disabledAttach } =this.props
        const root = this.props.root ? `${this.props.root}.` : ''

        const noAttach = disabledAttach ? disabledAttach : false

        let k = 0

        let accionesArchivosAdjuntos = [
            <BoxButton key="ba[2][0]" size={14} contrast name="plus-circle" onClick={ e => this.props.displayModalAddFile(true, 'Adjuntar archivo', 'create') } title="Adicionar archivo"  disabled={noAttach} />,
            <BoxButton key="ba[2][1]" size={14} contrast name="trash" onClick={ e => this.props.showHideModalDelete(true, 'Esta seguro que desea eliminar los archivos seleccionados?', () => { this.props.removeFiles(); this.props.showHideModalDelete(false) }) } title="Eliminar archivos" disabled={ files ? files.filter(x => x.get('selected')).count() === 0 : true } danger/>,
        ]

        if (!isAllowedToViewComponent(check, obj, '')) accionesArchivosAdjuntos = []

        return (
            <BoxSection title="Archivos adjuntos" actions={ accionesArchivosAdjuntos }>
                <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-solicitudes">
                    <thead>
                        <tr>
                            <th width="20px">
                                <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={ e => this.toggleSelectAllFiles(e.target.checked) } checked={ this.state.toggleAll } />
                            </th>
                            <th style={{ width: '5%' }}>No.</th>
                            <th style={{ width: '25%' }}>Archivo</th>
                            <th style={{ width: '15%' }}>Tipo</th>
                            <th style={{ width: '50%' }}>Observaciones</th>
                            <th style={{ width: '5%' }}>Descargar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {                            
                            (files &&  files.count() > 0) ? 
                                files.map((x, n) => {
                                    
                                    //k++
                                    return (
                                        <Fragment key={ `fr[23][${n}][${x.get('guid')}]` }>
                                        <tr key={ `tr[23][${n}][${x.get('guid')}]` } className={ x.get('selected') ? 'info' : '' }>
                                            <td><input type="checkbox" style={{ verticalAlign: 'middle' }} checked={ x.get('selected') || false } onChange={ (e) => this.props.updateInputs(`${root}adjuntos.${n}.selected`, e.target.checked) } disabled={ !x.get('editable') } /></td>
                                            <td className={ x.get('editable') === 1 ? 'LinkToEdit' : '' } style={{ textAlign: 'right' }} onClick={ x.get('editable') === 1 ? e => this.props.displayModalAddFile(true, 'Modificación de archivos', 'edit', x) : null }>{ n + 1 }</td>
                                            <td>{ this.setIcon(x.get('icono')) } { x.get('nombre') }</td>
                                            <td>{ x.get('clasificacion') }</td>
                                            <td>{ x.get('observaciones') }</td>
                                            <td>
                                                {
                                                    (x.get('id') &&
                                                        <FontAwesome name="download" onClick={ e => this.props.downloadFile( x.get('id'), x.get('nombre') ) } />
                                                    )
                                                }
                                            </td>
                                        </tr>

                                        {
                                            // x.getIn(['documento', 'documentos']) && x.getIn(['documento', 'documentos']).map((x1, n1) => {
                                                
                                            //     return (
                                            //         x1.get('adjuntos') && x1.get('adjuntos').map((x2, n2) => {
                                            //             k++
                                            //             return (
                                            //                 <tr key={ `tr[23][${n2}][${x2.get('guid')}]` } className={ x2.get('selected') ? 'info' : '' }> 
                                                                                                                           
                                            //                     <td><input type="checkbox" style={{ verticalAlign: 'middle' }} checked={ false } disabled /></td>

                                            //                     <td className={ '' } style={{ textAlign: 'right' }} onClick={ x2.get('editable') === 1 ? e => this.props.displayModalAddFile(true, 'Modificación de archivos', 'edit', x2) : null }>{ k }</td>

                                            //                     <td>{ this.setIcon(x2.get('icono')) } { x2.get('nombre') }</td>
                                            //                     <td>{ x2.get('clasificacion') }</td>
                                            //                     <td>{ x2.get('observaciones') }</td>
                                            //                     <td>
                                            //                         {
                                            //                             (x2.get('id') &&
                                            //                                 <FontAwesome name="download" onClick={ e => this.props.downloadFile( x2.get('id'), x2.get('nombre') ) } />
                                            //                             )
                                            //                         }
                                            //                     </td>
                                            //                 </tr>
                                            //             );
                                            //         })

                                            //     )

                                            // })
                                        }                                      

                                        </Fragment>

                                        
                                    )
                                })
                            :
                                <tr>
                                    <td colSpan={ 6 } style={{ textAlign: 'center' }}>Para adicionar nuevos archivos haga click en el botón <span style={{ color: '#888' }}><FontAwesome name="plus-circle" /></span></td>
                                </tr>
                        }












                    </tbody>
                </table>
                <ModalDelete />
            </BoxSection>
        )
    }
}

function mapStateToProps(state) {
    return {}
}

function mapDispatchToProps(dispatch) {
    return {
        downloadFile: (id, filename) => dispatch(downloadFile(id, filename)),
        displayModalAddFile: (show, title, mode, file) => dispatch(displayModalAddFile(show, title, mode, file)),
        showHideModalDelete: (show, message, action) => dispatch(showHideModalDelete(show, message, action))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AttachedFilesBox)


// WEBPACK FOOTER //
// ./src/components/Shared/AttachedFilesBox.jsx